import DOMPurify from 'dompurify';

export default app => {
  app.config.globalProperties.$sanitize = (html, isAllowStyle = true) =>
    DOMPurify.sanitize(html, {
      FORBID_TAGS: ['style', 'html', 'body', 'head', 'title', 'meta'],
      FORBID_ATTR: isAllowStyle ? [] : ['style']
    });
};
